import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useModal } from "@/hook";
import Button from "@/component/Button";
import { Modal } from "@/component/modal";
import { errorToast } from "@/component/Toast";

import AnswerEditor from "./AnswerEditor";


export const SENTENCE_ANSWER_MODAL_ID = "sentence-answer-modal-id";

const SentenceAnswerEditModal: React.FC = () => {
    const intl = useIntl();
    const modal = useModal();
    const data = modal.getData(SENTENCE_ANSWER_MODAL_ID);

    const [answers, setAnswers] = useState<string[]>();
    const [disabled, setDisabled] = useState<boolean>(false);

    const onClickConfirm = async () => {
        setDisabled(true);
        const newAnswers = (answers!.length === 1 && answers![0] === "") ? [] : answers!;
        await data?.onSubmit(newAnswers)
            .then(() => {
                modal.close(SENTENCE_ANSWER_MODAL_ID);
            })
            .catch(() => {
                errorToast(intl.formatMessage({ id: "t004" }));
            })
            .finally(() => {
                setDisabled(false);
            });
    };

    return (
        <Modal id={SENTENCE_ANSWER_MODAL_ID}
               size="md"
               title={intl.formatMessage({ id: "i03050" })}
               onClose={() => setDisabled(false)}
        >
            <div className="mt-2 text-black-400 text-[12px] font-[400] leading-[1.5]">
                {intl.formatMessage({ id: "i03051" })}
            </div>
            <div className="modal-body !gap-y-7.5">
                <AnswerEditor defaultAnswers={data?.answers}
                              updateAnswers={setAnswers}
                />

                <div className="modal-btn-group">
                    <Button size="sm"
                            variant="secondary"
                            disabled={disabled}
                            onClick={() => modal.close(SENTENCE_ANSWER_MODAL_ID)}
                    >
                        {intl.formatMessage({ id: "b0002" })}
                    </Button>
                    <Button size="sm"
                            variant="primary"
                            disabled={disabled}
                            onClick={onClickConfirm}
                    >
                        {intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default SentenceAnswerEditModal;
